export default __webpack_public_path__ + "static/media/star-off.9da727ed.svg";